import { Bill, BillState, useRepositoryQuery } from '@mews-commander/data-access';
import { sortByDescending } from '@mews-commander/utils';
import { DEFAULT_BILL_FETCH_EXTENT } from '@mews-commander/legacy-entities/src/actions/bills';

export const COMPANY_BILLS_GET_ALL_BY_ACCOUNT_ID_QUERY = 'companyBillsGetAllByAccountId';

interface UseCompanyBills {
    ownerId: string;
    enterpriseId: string;
}

const companyBillsExtent = {
    ...DEFAULT_BILL_FETCH_EXTENT,
    correctedBills: true,
    billProfiles: true,
};

export const useCompanyClosedBills = ({ ownerId, enterpriseId }: UseCompanyBills) =>
    useRepositoryQuery(
        'bills',
        'getAll',
        { ownerIds: [ownerId], enterpriseId, state: BillState.Closed, extent: companyBillsExtent },
        {
            select: ({ bills }) => {
                if (!bills) return [];

                return sortByDescending<Bill>('closedUtc')(bills);
            },
            refetchOnMount: 'always',
        }
    );
